export const common = {
  // Navigation
  "nav.home": "Accueil",
  "nav.about": "À Propos",
  "nav.services": "Services", 
  "nav.products": "Produits",
  "nav.certifications": "Certifications",
  "nav.partnerships": "Partenariats",
  "nav.contact": "Contact",
  "nav.quote": "Obtenir un Devis",
  
  // Common buttons
  "button.learnMore": "En Savoir Plus",
  "button.getQuote": "Obtenir un Devis",
  "button.contactUs": "Nous Contacter",
  "button.viewAll": "Voir Tout", 
  "button.download": "Télécharger",
  
  // Common text
  "company.name": "GROUPE DRIXEM",
  "company.tagline": "Spécialistes Malaisiens de l'Huile de Palme",
  "language.current": "Français"
};

export default common;